import React, { useState, useEffect } from "react";

function App() {
  const [email, setEmail] = useState("No email yet");
  const [inbox, setInbox] = useState("Inbox will appear here...");
  const [token, setToken] = useState("");
  const [intervalId, setIntervalId] = useState(null);

  // --- MAIN EMAIL GENERATOR ---
  async function createEmail() {
    setEmail("Generating...");
    try {
      const domRes = await fetch("https://api.mail.tm/domains");
      const domData = await domRes.json();
      const domains = domData["hydra:member"];
      const domain = domains[Math.floor(Math.random() * domains.length)].domain;

      const username = Math.random().toString(36).substring(2, 8);
      const address = `${username}@${domain}`;
      const pass = Math.random().toString(36).substring(2, 12);

      await fetch("https://api.mail.tm/accounts", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address, password: pass }),
      });

      const tokenRes = await fetch("https://api.mail.tm/token", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ address, password: pass }),
      });

      const tokenData = await tokenRes.json();
      setToken(tokenData.token);
      setEmail(address);
      getInbox(tokenData.token);

      if (intervalId) clearInterval(intervalId);
      const newInterval = setInterval(() => getInbox(tokenData.token), 10000);
      setIntervalId(newInterval);
    } catch (e) {
      console.error(e);
      setEmail("Error generating email!");
    }
  }

  // --- FETCH INBOX ---
  async function getInbox(authToken) {
    try {
      const res = await fetch("https://api.mail.tm/messages", {
        headers: { Authorization: "Bearer " + (authToken || token) },
      });
      const data = await res.json();
      if (!data["hydra:member"].length) {
        setInbox("<p>No new mails.</p>");
        return;
      }
      const mails = data["hydra:member"]
        .map(
          (m) => `
          <div class='mail'>
            <b>From:</b> ${m.from.address}<br>
            <b>Subject:</b> ${m.subject || "(No subject)"}<br>
            <small>${new Date(m.createdAt).toLocaleString()}</small>
          </div>`
        )
        .join("");
      setInbox(mails);
    } catch (e) {
      console.error(e);
      setInbox("Error loading inbox");
    }
  }

  useEffect(() => {
    return () => {
      if (intervalId) clearInterval(intervalId);
    };
  }, [intervalId]);

  // --- MAIN UI ---
  return (
    <div
      style={{
        fontFamily: "Arial, sans-serif",
        textAlign: "center",
        padding: "20px",
        background: "#f3f4f6",
      }}
    >
      {/* SEO Head Tags for AdSense */}
      <head>
        <title>Free Temporary Email Generator | Disposable Inbox</title>
        <meta
          name="description"
          content="Create free temporary email addresses instantly — no signup required. Receive emails online using a disposable inbox."
        />
        <meta
          name="keywords"
          content="temporary email, disposable email, temp mail, fake email, instant inbox"
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://yourfuturedomain.com/" />

        {/* Google AdSense Script */}
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-XXXXXXXXXXXX"
          crossOrigin="anonymous"
        ></script>
      </head>

      <h1 style={{ color: "#1e3a8a" }}>📧 Free Temporary Email Generator</h1>
      <p>Instantly create disposable email addresses — no registration or login required.</p>

      <button
        onClick={createEmail}
        style={{
          background: "#2563eb",
          color: "#fff",
          border: "none",
          padding: "10px 20px",
          borderRadius: "8px",
          cursor: "pointer",
        }}
      >
        Create Temporary Email
      </button>

      <div
        style={{
          margin: "15px auto",
          padding: "10px",
          background: "#fff",
          borderRadius: "8px",
          maxWidth: "400px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        {email}
      </div>

      {/* AdSense Banner Slot */}
      <div
        style={{
          margin: "20px auto",
          maxWidth: "728px",
          background: "#fff",
          padding: "10px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <ins
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-XXXXXXXXXXXX"
          data-ad-slot="1234567890"
          data-ad-format="auto"
          data-full-width-responsive="true"
        ></ins>
        <script>(adsbygoogle = window.adsbygoogle || []).push({});</script>
      </div>

      <div
        id="inbox"
        style={{
          margin: "20px auto",
          maxWidth: "500px",
          textAlign: "left",
          background: "#fff",
          padding: "10px",
          borderRadius: "8px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
        dangerouslySetInnerHTML={{ __html: inbox }}
      ></div>

      <footer style={{ marginTop: "30px", fontSize: "14px", color: "#555" }}>
        Made with ❤️ by Sheikh Dastgir
      </footer>
    </div>
  );
}

export default App;
